<template>
  <div class="s-reasons">
    <div class="s-reasons__main">
      <div class="s-reasons__txt">
        <div class="e-label">{{ dictionary.reasonsLabelText }}</div>
        <h2 class="mb-64" v-html="dictionary.reasonsHeaderText"></h2>
        <img
          v-if="records"
          :src="records[currentImage - 1].image.url"
          :alt="records[currentImage - 1].image.alt" />
      </div>
      <div v-if="records" class="s-reasons__cont">
        <div class="s-reasons__center-line-wrap">
          <div class="s-reasons__center-line"></div>
        </div>
        <div
          v-for="(item, index) in records"
          :key="index"
          class="trigger mb-48">
          <div class="s-reasons__num mb-40">
            {{
              Number(index + 1)
                .toString()
                .padStart(2, '0')
            }}
          </div>
          <h3 class="h3 mb-24">{{ item.title }}</h3>
          <div class="s-reasons__description" v-html="item.description"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from './../../lib/lib'
import jQuery from 'jquery'

export default {
  data() {
    return {
      currentImage: 1,
      records: null,
    }
  },
  mounted() {
    const { records } = lib.getData('reasonsData')
    this.records = records

    this.$nextTick(() => {
      this.scrollMagicInit()
    })
  },
  methods: {
    scrollMagicInit() {
      // eslint-disable-next-line no-undef
      const controller = new ScrollMagic.Controller()

      document.querySelectorAll('.trigger').forEach((i) => {
        const index = i.getElementsByClassName('s-reasons__num')[0].innerHTML

        // eslint-disable-next-line no-undef
        new ScrollMagic.Scene({
          triggerElement: i,
          duration: jQuery('.trigger').outerHeight(),
        })
          // .addIndicators()
          .addTo(controller)
          .on('enter', () => {
            this.currentImage = Number(index)
          })
      })
    },
  },
}
</script>
